import { StorageGetItem } from "../../admin/components/StorageComp";

export const authData = () => {
    const authDataAce =  StorageGetItem("authDataAceNew");
    if(authDataAce){
      return JSON.parse(authDataAce);
    }else{
      return null;
    }
  }